module.exports = [
  require('./users.js'),
  require('./tags.js'),
  require('./notifications.js'),
  require('./sessions.js'),
  require('./ghost.js'),
  require('./logs.js')
]
